<template>
  <div class="provinces">
    <va-page-header>

      <div v-if="provinces !== null" slot="title">
        <span>Manage provinces</span>
      </div>

      <div v-if="provinces !== null" slot="actions">
        <!-- <va-button style="position: absolute; right: 22px; top: 70px;" type="primary" @click.native="navigate('/survey')">New Survey</va-button> -->
        <!-- <va-button @click.native="navigate('/survey')" style="position: absolute; right: 22px; top: 70px;" type="primary" size="lg">NEW SURVEY</va-button> -->
      </div>

    </va-page-header>
    <va-table v-if="provinces !== null" :hover="true" :full-width="true" class="datatable">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Seats(m)</th>
            <th>Seats(f)</th>
            <th>Total PCs</th>
            <!-- <th>Male Stations</th>
            <th>Female Stations</th>
            <th>Kuchi Stations</th>
            <th>Hindu Stations</th> -->
            <th>Voters(m)</th>
            <th>Voters(f)</th>
            <th>Kuchi Voters</th>
            <th>Hindu Voters</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="province in provinces" style="height:38px">
            <td>{{ province.id }}</td>
            <td>
              <!-- {{province.name}} -->
              <!-- <va-button type="link" @click.native="navigate('/province/' + province.id)">{{ province.name }}</va-button> -->
              <a style="cursor:pointer" @click="navigate('/province/' + province.id)">{{province.name}}</a>
            </td>
            <td>{{ province.male }}</td>
            <td>
              {{ province.female }}
            </td>
            <td>{{province.pcs}}</td>
            <!-- <td>{{province.male_ps}}</td>
            <td>{{province.female_ps}}</td>
            <td>{{province.kuchi_ps}}</td>
            <td>{{province.hindu_ps}}</td> -->
            <td>{{province.male_votes}}</td>
            <td>{{province.female_votes}}</td>
            <td>{{province.kuchi_votes}}</td>
            <td>{{province.hindu_votes}}</td>
            <td>
              <va-dropdown>
                <div slot="trigger">
                  <va-icon type="ellipsis-h" margin="0 0 0 7px"></va-icon>
                </div>

                <li>

                  <a @click="deleteSurvey(province.id)">Delete</a>
                </li>
              </va-dropdown>
            </td>

          </tr>
        </tbody>
      </table>
    </va-table>

    <loader v-else-if="loading" />

    <div v-else :class="$style.deadCenter">
      <p>No provinces available</p>
      <br>
      <va-button type="primary" @click.native="navigate('/survey')">New Survey</va-button>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import {
    mapGetters,
    mapActions
  } from "vuex";
  import loader from "@/components/Loader";
  export default {
    name: "home",
    data() {
      return {
        loading: true,
        provinces: null,
      };
    },
    components: {
      loader
    },
    computed: {
      // ...mapGetters(["getSurveys"])
    },
    methods: {
      // ...mapActions(["fetchSurveys"]),
      navigate(to) {
        this.$router.push(to);
      },
      deleteSurvey(id) {
        this.VaModal.alert({
          title: 'Are you sure!',
          message: 'Please make sure if you want to delete this survey. All results related to this survey will also be deleted.',
          type: "danger",
          width: 500,
          onConfirm() {
            db.collection("surveys").doc(id).delete();
          }
        })
      }
    },
    mounted() {
      var provinces = [];
      var provincesRef = db.collection("provinces");
      if (provincesRef !== null) {
        provincesRef.get().then(snap => {
          provinces = [];
          snap.forEach(doc => {
            provinces.push({
              id: doc.id,
              ...doc.data()
            });
          });
          // this.$store.commit("updateprovinces", provinces);
          this.provinces = provinces.sort((a, b) => a.id - b.id);
          this.loading = false;
          // setTimeout(() => this.loading = false, 2000);
        });
      }
    }
  };
</script>

<style module>
  .va-page-header-breadcrumb-wrapper {
    display: none;
  }

  .deadCenter {
    bottom: 0;
    height: 100px;
    left: 0;
    margin: auto;
    position: absolute;
    top: 0;
    right: 0;
    text-align: center;
  }

  .horCenter {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
  }

  .loader {
    margin: auto;
    text-align: center;
  }

  .homeContent {
    text-align: center;
  }
</style>